import {
  getCustomerOrderStatusTitle,
  getSupplierOrderStatusTitle,
  isOrderAccepted,
  isOrderRejected,
  OrderStatus,
} from '@/models/OrderStatus';

const getOrderStatusClasses = (status: OrderStatus) => {
  if (isOrderAccepted(status)) {
    return 'bg-green-100 text-green-700';
  }

  if (isOrderRejected(status)) {
    return 'bg-red-100 text-red-700';
  }

  if (status === OrderStatus.Canceled) {
    return 'bg-gray-200 text-gray-700';
  }

  if (status === OrderStatus.Submitted) {
    return 'bg-blue-100 text-blue-700';
  }

  return 'bg-yellow-100 text-yellow-700';
};

interface OrderStatusBadgeProps {
  order: {
    status: OrderStatus;
    editedBySupplier?: boolean;
  };
  isSupplier?: boolean;
}

const OrderStatusBadge = ({ order, isSupplier = false }: OrderStatusBadgeProps) => {
  const title = isSupplier
    ? getSupplierOrderStatusTitle(order)
    : getCustomerOrderStatusTitle(order);
  const classes = getOrderStatusClasses(order.status);

  return (
    <span
      className={`inline-block mt-0.5 px-2 py-0.5 rounded-full text-[11px] font-medium ${classes}`}
    >
      {title}
    </span>
  );
};

export default OrderStatusBadge;
